import React from 'react';
import { Text } from '../../../Text';
import { block } from '../../../utils/cn';
import './SelectCounter.css';
const b = block('select-counter');
export function SelectCounter({ count, size, disabled }) {
    return (React.createElement("div", { className: b({ size }) },
        React.createElement(Text, { variant: size === 'xl' ? 'body-2' : 'body-1', color: disabled ? 'hint' : 'primary', className: b('text') }, count)));
}
